module.exports = __webpack_public_path__ + "img/IND-i-1-II.3a2a1e47.png";